import React, { createContext, useContext, useState, ReactNode } from 'react';

interface CartItem {
    id: string;
    title: string;
    image: string;
    type: 'trend' | 'method';
}

interface CartContextType {
    items: CartItem[];
    addItem: (item: CartItem) => void;
    removeItem: (id: string, type: 'trend' | 'method') => void;
}

const CartContext = createContext<CartContextType | undefined>(undefined);

export const CartProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [items, setItems] = useState<CartItem[]>([]);

    const addItem = (item: CartItem) => {
        setItems(prev => {
            const itemExists = prev.some(existingItem =>
                existingItem.id === item.id && existingItem.type === item.type
            );
            if (itemExists) {
                return prev;
            }
            return [...prev, item];
        });
    };

    const removeItem = (id: string, type: 'trend' | 'method') => {
        setItems(prev => {
            const indexToRemove = prev.findIndex(item =>
                item.id === id && item.type === type
            );
            if (indexToRemove === -1) return prev;

            return prev.filter((_, index) => index !== indexToRemove);
        });
    };

    return (
        <CartContext.Provider value={{ items, addItem, removeItem }}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => {
    const context = useContext(CartContext);
    if (context === undefined) {
        throw new Error('useCart must be used within a CartProvider');
    }
    return context;
};